import { system } from '@eastcoal/common/config/system'
import { setupCaptcha } from '@eastcoal/common/lib/captcha'
import { setupWxobs } from '@eastcoal/common/lib/donut'
import { setupRum } from '@eastcoal/common/lib/rum'
import { setupApplicationStore } from '@eastcoal/common/store/application/helpers/setup'
import { isReportLog } from '@eastcoal/common/store/application/helpers/util'
import { setupDayjsLocale } from '@eastcoal/common/utils/date'
import { normalizeUrl } from '@eastcoal/common/utils/url'

import { setupFormily } from '@eastcoal/formily/setup'

import { ApplicationType } from '@eastcoal/shared/enums/ApplicationType'

import {
  BUILD_MODE,
  API_SERVER_URL,
  WEB_OFFICE_APP_ID,
  MALL_BASE_URL,
  MEMBER_BASE_URL,
  OPERATION_BASE_URL,
  WEB_OFFICE_SERVER_URL,
  RUM_APP_ID,
  WXOBS_APP_ID,
  SUPPORT_BASE_URL,
  APP_VERSION,
  CIPHER_SECRET,
  CIPHER_IV
} from './utils/constants'

// 一定要保证该方法在所有页面加载之前执行
system.init({
  env: {
    appName: 'mall',
    appType: ApplicationType.MALL,
    appVersion: APP_VERSION,
    mode: BUILD_MODE,
    isProd: BUILD_MODE === 'prod'
  },
  api: {
    baseURL: API_SERVER_URL,
    timeout: 30000,
    ignore401: true
  },
  router: {
    mallBaseUrl: MALL_BASE_URL,
    memberBaseUrl: MEMBER_BASE_URL,
    operationBaseUrl: OPERATION_BASE_URL,
    supportBaseUrl: SUPPORT_BASE_URL,
    loginUrl: normalizeUrl(MEMBER_BASE_URL, '/login'),
    whitelist: ['/debugger']
  },
  webOffice: {
    appId: WEB_OFFICE_APP_ID,
    serverUrl: WEB_OFFICE_SERVER_URL
  }
})

system.setter.message({
  duration: 2
})

system.setter.notification({
  duration: 2
})

setupFormily()
setupDayjsLocale()
setupApplicationStore({
  async getCipherApi() {
    return {
      secret: CIPHER_SECRET,
      iv: CIPHER_IV
    }
  }
})

setupCaptcha()

if (system.env.isProd && isReportLog()) {
  setupRum({
    pid: RUM_APP_ID
  })
  setupWxobs({
    projectId: WXOBS_APP_ID
  })
}
